import fetchData from "utils/fetchData";
import { useEffect, useState, useMemo, useContext } from "react";
import File from "components/File";
import { FcOpenedFolder } from 'react-icons/fc';
import { UserContext } from "utils/context";
import helpers from "utils/helpers";
import Upload from "components/Upload";
import Preview from "components/Preview";
import Path from "./Path";
import { useParams, useNavigate } from "react-router";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { Modal, Tooltip } from "@nextui-org/react";

const Explorer = () => {
    const initial_options = { type: "", name: "" };
    const [user] = useContext(UserContext);
    const [folders, setFolders] = useState([]);
    const [path, setPath] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [selectFile, setSelectFile] = useState(null);
    const [visible, setVisible] = useState(false);
    const [options, setOptions] = useState({ ...initial_options });
    const { id } = useParams();
    const navigate = useNavigate();

    const select = (folder) => setPath([...path, folder]);

    useEffect(() => {
        const get_folders = async () => {
            let { data, error } = await fetchData({
                url: "folders", cache: true
            });
            if (!error) setFolders(data);
        }

        get_folders();
    }, []);

    useEffect(() => {
        const get_files = async () => {
            let { data, error } = await fetchData({
                url: "documents?users_id=" + (id ? id : user.id)
            });
            if (!error) setDocuments(data);
        }

        get_files();
    }, [user, id]);

    const list_folders = useMemo(() => {
        return folders.filter(item => {
            if (path.length) return item.folders_id === path[path.length - 1]?.id;
            return item.folders_id === null;
        });
    }, [folders, path]);

    const list_documents = useMemo(() => {
        return documents.filter(item => path[path.length - 1]?.id === item.folders_id)
    }, [documents, path, folders]);

    const container = useMemo(() => {
        return folders.find(item => item.folders_id === (path[path.length - 1]?.id || null));
    }, [folders, path]);

    return <div className="page">
        <aside>
            {(!container && folders.length !== 0) &&
                <button onClick={() => setVisible(true)}>
                    <AiOutlineCloudUpload />
                    <p>Déposer un document</p>
                </button>}

            <Modal
                className="card"
                closeButton
                aria-labelledby="modal-title"
                open={visible}
                onClose={() => setVisible(false)}
                width="600px"
                scroll>
                <Modal.Header>
                    <h1 className="gradient" >
                        Déposer un document
                    </h1>
                </Modal.Header>
                <Modal.Body css={{ padding: 0 }}>
                    <Upload
                        onSuccess={(data) => {
                            setDocuments(old => [...old, ...data]);
                            setVisible(false);
                        }}
                        folders_id={path.length ? path[path.length - 1].id : null}
                        users_id={(id ? id : user.id)}
                        visible={visible}
                        setVisible={setVisible}
                    />
                </Modal.Body>
            </Modal>


            <form style={{ width: 280 }} className="card">
                <div className="group">
                    <label>Recherche par nom</label>
                    <input onChange={e => setOptions({ ...options, name: e.target.value })} value={options.name} type="text" placeholder="Rechercher un document" />
                </div>

                <div className="group">
                    <label>Type de document</label>
                    <div>
                        {[{ id: "", title: "tous" }, { id: "a", title: "test" }].map(type => <div key={type.id} className="radio">
                            <input onChange={() => setOptions({ ...options, type: type.id })} htmlFor={"radio-" + type.id} name="radio" type="radio" checked={(options.type === type.id)} />
                            <label onClick={() => setOptions({ ...options, type: type.id })} id={"radio-" + type.id} className="radio-label">{type.title}</label>
                        </div>)}
                    </div>
                </div>


                {(options.name !== "" || options.type !== "") && (
                    <button onClick={() => setOptions({ ...initial_options })} className="error" style={{ alignSelf: "center" }}>Rénitialiser</button>
                )}
            </form>
        </aside>
        <main>
            <div className="head">
                <Path setPath={setPath} path={path} />
                {(Boolean(id)) && <button onClick={() => navigate(-1)}>Retour</button>}
            </div>


            <div className="wrapper">
                <Preview file={selectFile} setFile={setSelectFile} />
                {list_folders.map(item => <File key={item.id} onClick={() => select(item)} icon={<FcOpenedFolder />} name={item.name} />)}
                {list_documents.map(item => {
                    const icon = helpers.mimetype_to_icon(item.mimetype);
                    const name = item.name.replace(/\.[^/.]+$/, "");
                    return <File key={item.id} icon={icon} name={name} onClick={() => setSelectFile(item)} />
                })}
            </div>
        </main>
    </div>
}

export default Explorer;